import type { TBucket } from '@crm/entities/deals-board';

export const bucketTitleKeys: Record<TBucket['key'], string> = {
    lost: 'crm.deals.board.bucket.title.lost',
    postponed: 'crm.deals.board.bucket.title.postponed',
    'in_work_or_finished': 'crm.deals.board.bucket.title.inWorkOrFinished',
};

export const bucketEmptyTitleKeys: Record<TBucket['key'], string> = {
    lost: 'crm.deals.board.bucket.emptyTitle.lost',
    postponed: 'crm.deals.board.bucket.emptyTitle.postponed',
    'in_work_or_finished': 'crm.deals.board.bucket.emptyTitle.inWorkOrFinished',
};

export const bucketSubTitleKeys: Record<TBucket['key'], string> = {
    lost: 'crm.deals.board.bucket.subTitle.lost',
    postponed: 'crm.deals.board.bucket.subTitle.postponed',
    'in_work_or_finished': 'crm.deals.board.bucket.subTitle.inWorkOrFinished',
};
